import './card-month.scss';
import {
	CategoryScale,
	Chart,
	LineController,
	LineElement,
	LinearScale,
	PointElement,
	Tooltip,
} from 'chart.js';

export default () => {
	Chart.register(
		LineController,
		LineElement,
		PointElement,
		LinearScale,
		CategoryScale,
		Tooltip
	);

	// Line chart
	const lineCharts = document.querySelectorAll( '.line_Chart' );

	lineCharts.forEach( ( chart ) => {
		lineChart( chart, chart.dataset.data, chart.dataset.color, chart.dataset.name );
	} );

	function lineChart ( chart, data, colors, barName ) {
		new Chart( chart, {
			type: 'line',
			data: {
				datasets: [ {
					label: 'My Line Dataset',
					data: [
						{
							x: 0.5,
							y: 0,
						},
						{
							x: 1,
							y: 0.8,
						},
						{
							x: 2,
							y: 1.2,
						},
						{
							x: 5,
							y: 1.1,
						},
						{
							x: 5,
							y: 1.5,
						},
						{
							x: 6,
							y: 1.6,
						},
						{
							x: 7,
							y: 2,
						},
						{
							x: 8,
							y: 1.2,
						},
						{
							x: 9,
							y: 1.4,
						},
						{
							x: 10,
							y: 2.1,
						},
						{
							x: 11,
							y: 1.2,
						},
						{
							x: 11,
							y: 3,
						},
						{
							x: 13,
							y: 2.4,
						},
						{
							x: 14,
							y: 2.5,
						},
						{
							x: 15,
							y: 2.9,
						},
						{
							x: 16,
							y: 2.7,
						},
						{
							x: 17,
							y: 2.8,
						},
						{
							x: 18,
							y: 2.9,
						},
						{
							x: 19,
							y: 4,
						},
						{
							x: 20,
							y: 3.2,
						},
						{
							x: 21,
							y: 3.6,
						},
						{
							x: 22,
							y: 3.7,
						},
						{
							x: 23,
							y: 3.8,
						},
						{
							x: 24,
							y: 3.9,
						},
						{
							x: 25,
							y: 3,
						},
						{
							x: 26,
							y: 4.1,
						},
						{
							x: 27,
							y: 4.2,
						},
						{
							x: 28,
							y: 4.3,
						},
						{
							x: 29,
							y: 4.4,
						},
						{
							x: 30,
							y: 4.5,
						},
					],
					borderColor: JSON.parse( colors ),
					tension: 0.25,
					fill: false,
					pointRadius: 0,
					borderWidth: 2,
				} ],
			},
			options: {
				responsive: true,
				scales: {
					x: {
						type: 'linear',
						min: 1,
						max: 30,
						title: {
							display: true,
							text: 'Dates',
							font: {
								size: 12,
								weight: 'medium',
							},
							color: '#000',
						},
						ticks: {
							stepSize: 1,
							// MaxTicksLimit: 6,
						},
					},
					y: {
						type: 'linear',
						min: 1,
						max: 5,
						beginAtZero: true,
						title: {
							display: true,
							text: barName,
							font: {
								size: 12,
								weight: 'medium',
							},
							color: '#000',
						},
						ticks: {
							stepSize: 1,
							// MaxTicksLimit: 6,
						},
					},
				},
			},
		} );
	}
};
